import { ImpactBlockFragment } from '@/__generated__/graphql';
import { buttonTemplate, colors, GridWrapper, mediaQueries } from '@theme/lib';
import { ReactElement } from 'react';
import styled from 'styled-components';

const ImpactBlockWrapper = styled(GridWrapper)`
  // Specific tag styling
  .btn-primary {
    ${buttonTemplate}
    color: ${colors.white};
    background-color: ${colors.ocean};
    font-size: 0.875rem;
    line-height: 1rem;
    font-weight: 400;
    margin-top: 1rem;
    text-align: center;
    white-space: normal;

    &:hover {
      text-decoration: none;
      border-color: ${(props) => props.theme.colors.button.primary.focusBorder};
    }

    &::after {
      display: none;
    }

    ${mediaQueries.lg} {
      font-size: 1.125rem;
      line-height: 1.35rem;
    }
  }

  .title-block {
    color: ${colors.white};
    font-weight: 400;
    font-size: 1.5rem;
    line-height: 1.6rem;

    ${mediaQueries.lg} {
      font-size: 2.25rem;
      line-height: 2.475rem;
    }
  }

  border: 5px solid ${colors.ocean};
  border-radius: ${props => props.theme.config.componentRadius};
  padding: 1.5rem;
`;

export default function ImpactBlock({ title, alignment, callToAction }: ImpactBlockFragment): ReactElement<any> {
  return <ImpactBlockWrapper alignment={alignment}>
    <div className="title-block">
      {title}
    </div>
    <a href={callToAction.url} target={callToAction.target ? callToAction.target : undefined} className="btn btn-primary">
      {callToAction.title}
    </a>
  </ImpactBlockWrapper>;
}
